import { FC, RefAttributes, useCallback, useRef, useState } from "react"
import { OverlayTrigger, Tooltip, TooltipProps } from "react-bootstrap";
import { isMobileOrTablet } from "src/helpers";
import { useOnClickOutside } from "src/hooks/useClickOutside";


const InsuranceTitle: FC = (): JSX.Element => {
  const [infoIconIndex, changeInfoIconIndex] = useState<number>(-1);
  const toggleIconRef = useRef<HTMLElement | null>(null);

  useOnClickOutside(toggleIconRef, () => {
    changeInfoIconIndex(-1);
  });

  const handleIconClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();
    changeInfoIconIndex(infoIconIndex !== 4 ? 4 : -1);
  };

    const tooltipOverlay = useCallback(
        (props: JSX.IntrinsicAttributes & TooltipProps & RefAttributes<HTMLDivElement>) => (
            <Tooltip {...props}  className={`${props.className || ""} custom-insurance-tooltip`}>
                <p>
                    Type at least 3 characters to find and select the correct insurance. If the insurance is not listed, select
                    Other and enter the information under Plan Name. Please also provide the <strong>Group ID &amp; Phone #</strong>.
                    Once the case is received and thoroughly reviewed, we can confirm if the insurance exists in the database and
                    update as needed.
                </p>
            </Tooltip>
        ),
        []
    );

    return (
        <span>
                <OverlayTrigger 
                    trigger={["click", "hover"]}
                    overlay={tooltipOverlay}
                    placement="auto"                   
                >
                    <i className="bi bi-question-circle-fill ms-2"></i>    
                </OverlayTrigger>
        </span>
    );
}

export default InsuranceTitle
